import { useLoggedInUser } from 'app/auth/useLoggedInUser';
import { PageClaim } from 'gen/ApiClient';
import { useMemo } from 'react';
import { calculateHasAccess } from './calculateHasAccess';

export const useUserHasPageClaim = (pageClaim: PageClaim): boolean => {
	const user = useLoggedInUser();
	return useMemo(() => calculateHasAccess(pageClaim, user), [pageClaim, user]);
};
